import { createSlice } from "@reduxjs/toolkit";
import {
  getJournalEntries,
  getTradeReview,
  createTradeReview,
  editTradeReview,
  deleteTradeReview,
  getUserReviews,
} from "./thunks";
import { logout, expiredLogout } from "../auth/thunks";
import {
  addFulfilledCases,
  setField,
  setFieldFromPayloadKey,
} from "../utils/asyncHandlers";

const initialState = {
  journalentries: {},
  tradeReview: {},
  userReviews: [],
};

const journalSlice = createSlice({
  name: "journal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addFulfilledCases(
      builder,
      [getTradeReview, createTradeReview, editTradeReview],
      setField("tradeReview")
    );
    builder
      .addCase(getJournalEntries.fulfilled, setField("journalentries"))
      .addCase(deleteTradeReview.fulfilled, (state) => {
        state.tradeReview = {};
      })
      .addCase(
        getUserReviews.fulfilled,
        setFieldFromPayloadKey("userReviews", "reviews", [])
      )
      .addCase(logout.fulfilled, (state) => {
        state.journalentries = null;
      })
      .addCase(expiredLogout.fulfilled, (state) => {
        state.journalentries = null;
      });
  },
});

export default journalSlice.reducer;
